import {FieldHelperProps} from 'formik';
import {FC, useEffect} from 'react';

import {PriceWithUsd} from 'components/currency/price-with-usd';
import {QuotedPaymentMethodFormInputValues} from 'forms/quotes/quote-form'
import {
    MinimalQuotedPaymentMethodFragment,
    ProductTaxFragment,
    QuotedPaymentMethodFormInput,
} from 'generated/graphql';
import {calculatePaymentMethodTotalPriceWithTax, calculateTaxesPaymentMethodAggregate, QuotedProductPriceFields} from 'utils/quotes/calculator';

interface PaymentMethodTotalPriceWithTaxProps {
    products: QuotedProductPriceFields[];
    paymentMethod: Omit<MinimalQuotedPaymentMethodFragment, 'originalPaymentMethod'>;
    fieldHelpers?: FieldHelperProps<QuotedPaymentMethodFormInputValues[]>;
    currentPaymentMethods?: QuotedPaymentMethodFormInput[];
    taxes: ProductTaxFragment[];
    exchangeRate?: number | null;
};

export const PaymentMethodTotalPriceWithTax: FC<PaymentMethodTotalPriceWithTaxProps> = ({
    products,
    paymentMethod,
    fieldHelpers,
    currentPaymentMethods,
    taxes,
    exchangeRate,
}) => {
    const price = calculatePaymentMethodTotalPriceWithTax(products, paymentMethod, taxes);

    useEffect(() => {
        if (currentPaymentMethods && !!taxes.length) {
            fieldHelpers?.setValue(calculateTaxesPaymentMethodAggregate(currentPaymentMethods, paymentMethod, taxes, products) as QuotedPaymentMethodFormInputValues[]);
        }
    }, [taxes, price]);

    return <PriceWithUsd brlAmount={price} exchangeRate={exchangeRate} />;
};
